<template>
  <Modal
    full-height
    :modal-style="{ maxWidth: '90vw' }"
    :title="$t('debug_mention_modal.debug_info')"
  >
    <div
      key="form"
      class="q-pa-xs"
      :class="{ 'q-pa-lg': $isDesktop }"
    >
      <VueJsonPretty
        class="json-pretty"
        :data="sortedMention"
      />
    </div>
    <template #buttons>
      <BaseButton
        color="primary"
        icon="copy"
        :label="$t('debug_mention_modal.copy_debug')"
        new-design
        new-icon
        @click="copyDebugToClipboard"
      />
    </template>
  </Modal>
</template>

<script>
import { BaseButton } from "shared/components/base";
import Modal from "shared/components/core/modals/Modal.vue";
import useClipboard from "shared/composables/useClipboard";
import { deepSortObjectByKeys } from "shared/helpers/object";

export default {
  name: "DebugMentionModal",
  components: {
    Modal,
    BaseButton,
  },
  props: {
    mention: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { copyToClipboard } = useClipboard();

    return { copyToClipboard };
  },
  computed: {
    sortedMention() {
      return deepSortObjectByKeys(this.mention);
    },
  },
  methods: {
    copyDebugToClipboard() {
      this.copyToClipboard(JSON.stringify(this.sortedMention, null, 2));
    },
  },
};
</script>

<style lang="scss" scoped>
.json-pretty {
  :deep(.vjs-value__string) {
    color: #0c63b1;
  }
}
</style>
